import { Box, Typography } from "@mui/material";
import React from "react";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  darkMode: boolean;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  darkMode,
}) => (
  <Box sx={{ mb: { xs: 3, sm: 4 } }}>
    <Typography
      variant="h4"
      sx={{
        fontFamily: '"Lexend", sans-serif',
        fontWeight: 800,
        fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" },
        background: darkMode
          ? "linear-gradient(135deg, #FFFFFF 0%, #E4E4E7 50%, #A1A1AA 100%)"
          : "linear-gradient(135deg, #0F172A 0%, #1E293B 50%, #334155 100%)",
        backgroundClip: "text",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        mb: 0.75,
        letterSpacing: "-0.02em",
        lineHeight: { xs: 1.3, sm: 1.2 },
      }}
    >
      {title}
    </Typography>

    {subtitle && (
      <Typography
        variant="h6"
        sx={{
          color: darkMode ? "var(--neutral-300)" : "var(--neutral-600)",
          fontSize: { xs: "0.875rem", sm: "1rem" },
          fontWeight: 400,
          lineHeight: 1.6,
        }}
      >
        {subtitle}
      </Typography>
    )}
  </Box>
);

export default PageHeader;
